import React, { Fragment, ReactNode } from 'react';
import { common } from '@kurtosys/ksys-app-template';
import { observer } from 'mobx-react';

import { ComponentBase } from '../../../shared/ComponentBase.js';
import { InjectedStyledComponent } from '../../../shared/InjectedStyledComponent.js';
import Translate from '../Translate/Translate.js';
import VisuallyHidden from '../VisuallyHidden/VisuallyHidden.js';

import { IDefinitionListItem } from './models/IDefinitionListItem.js';
import { IDefinitionListConfiguration, IDefinitionListProps, IDefinitionListState } from './models/index.js';
import Definition from './styledComponents/Definition.js';
import ListItem from './styledComponents/ListItem.js';
import Separator from './styledComponents/Separator.js';
import Term from './styledComponents/Term.js';
import Wrapper from './styledComponents/Wrapper.js';
import { DEFINITION_LIST_CATEGORY_KEY, DEFINITION_LIST_COMPONENT_KEY } from './DefinitionList.meta.js';

export class DefinitionList extends ComponentBase<
	IDefinitionListProps,
	IDefinitionListState,
	IDefinitionListConfiguration
> {
	categoryKey = DEFINITION_LIST_CATEGORY_KEY;
	componentKey = DEFINITION_LIST_COMPONENT_KEY;

	constructor(props: IDefinitionListProps) {
		super(props);
	}
	get cleanItems(): IDefinitionListItem[] {
		const { items = [], removeEmptyItems = false } = this.props;
		const cleanItems = !removeEmptyItems
			? items
			: items.filter((item) => {
					const { term, definition } = item;
					return !common.commonUtils.isNullOrEmpty(term) || !common.commonUtils.isNullOrEmpty(definition);
			  });
		return cleanItems;
	}

	term(term: string | undefined, visuallyHideTerm: boolean): ReactNode {
		const { termSuffix = '' } = this.props;
		if (term) {
			const termNode = (
				<Term>
					<Translate>{term}</Translate>
					{termSuffix}
				</Term>
			);
			if (visuallyHideTerm) {
				return <VisuallyHidden>{termNode}</VisuallyHidden>;
			}
			return termNode;
		}
		return null;
	}
	render() {
		const { className, itemSeparator = null } = this.props;
		const items = this.cleanItems;
		return (
			<Wrapper className={className}>
				{items.map((item, itemIndex) => {
					const { term, visuallyHideTerm = false, definition } = item;
					return (
						<Fragment key={term || `definition-fragment-${itemIndex}`}>
							{itemIndex > 0 && itemSeparator && <Separator>{itemSeparator}</Separator>}
							<ListItem key={term || `definition-item-${itemIndex}`}>
								{this.term(term, visuallyHideTerm)}
								<Definition>
									<Translate>{definition}</Translate>
								</Definition>
							</ListItem>
						</Fragment>
					);
				})}
			</Wrapper>
		);
	}
}

export default InjectedStyledComponent(
	observer(DefinitionList),
	DEFINITION_LIST_CATEGORY_KEY,
	DEFINITION_LIST_COMPONENT_KEY,
);
